import {Link} from "react-router-dom";
import { Col } from 'react-bootstrap';

import "./LinkBox.css";

interface LinkBoxProps
{
    name: string,
    href: string,
    image: string, 
    offset: number
}

function LinkBox(props:LinkBoxProps)
{
    return (
        <Col className="column" md={{ span: 5, offset: props.offset }} sm={{ span: 10, offset: 1}} >
          <p>{props.name}</p>
          <Link to={props.href}>
            <img className="img-responsive LinkBox" src={props.image} width={"100%"} alt={props.name}/>
          </Link>
        </Col>
    )
}

export default LinkBox;